import { weddingConfig } from '@/data/weddingConfig';
import { weddingImages } from '@/data/weddingImages';
import WeddingImage from '@/components/base/WeddingImage';
import ScrollReveal from '@/components/feature/ScrollReveal';

export default function OurStory() {
  const [large, smallA, smallB] = weddingImages.story;

  return (
    <section className="relative w-full bg-background-50 py-16 md:py-24">
      <div className="mx-auto max-w-3xl px-6">
        <ScrollReveal>
          <div className="text-center">
            <p className="micro-label mb-5 text-foreground-500">Nuestra historia</p>
            <div className="mx-auto h-px w-16 bg-primary-300" />
          </div>
        </ScrollReveal>

        {/* Asymmetric magazine-spread composition */}
        <div className="mt-14 md:mt-16">
          {large && (
            <ScrollReveal delay={1}>
              <div className="mx-auto w-[92%] sm:w-[80%]">
                <div className="relative overflow-hidden">
                  <WeddingImage
                    src={large.src}
                    fallback={large.fallback}
                    alt={large.alt}
                    className="h-80 w-full object-cover object-center sm:h-[26rem] md:h-[32rem]"
                  />
                </div>
              </div>
            </ScrollReveal>
          )}

          {weddingConfig.storyText && (
            <ScrollReveal delay={2}>
              <p className="mx-auto mt-10 max-w-xl text-center font-heading text-base italic leading-relaxed text-foreground-600 sm:text-lg md:text-xl">
                {weddingConfig.storyText}
              </p>
            </ScrollReveal>
          )}

          {/* Offset smaller photos */}
          {(smallA || smallB) && (
            <div className="mt-12 flex items-start justify-center gap-5 sm:gap-10">
              {smallA && (
                <ScrollReveal delay={3}>
                  <div className="w-[34%] max-w-[160px] -translate-y-3 overflow-hidden sm:-translate-y-5">
                    <WeddingImage
                      src={smallA.src}
                      fallback={smallA.fallback}
                      alt={smallA.alt}
                      className="aspect-[3/4] w-full object-cover object-center"
                    />
                  </div>
                </ScrollReveal>
              )}
              {smallB && (
                <ScrollReveal delay={4}>
                  <div className="w-[40%] max-w-[200px] translate-y-4 overflow-hidden sm:translate-y-6">
                    <WeddingImage
                      src={smallB.src}
                      fallback={smallB.fallback}
                      alt={smallB.alt}
                      className="aspect-[3/4] w-full object-cover object-center"
                    />
                  </div>
                </ScrollReveal>
              )}
            </div>
          )}
        </div>
      </div>
    </section>
  );
}